'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialWhatsappOriginalAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.10352e-05 24L1.69633 17.8403C0.647625 16.0323 0.0974822 13.9848 0.103213 11.8916C0.103213 5.3327 5.46711 0 12.0516 0C15.2493 0 18.2522 1.23764 20.5043 3.48479C22.7622 5.73194 24.0058 8.72053 24 11.8973C24 18.4563 18.6362 23.789 12.0459 23.789H12.0402C10.0402 23.789 8.07455 23.2871 6.3267 22.3403L6.10352e-05 24ZM6.63043 20.1901L6.99146 20.4068C8.51581 21.308 10.2637 21.7814 12.0459 21.7871H12.0516C17.5244 21.7871 21.9829 17.3555 21.9829 11.903C21.9829 9.26236 20.9513 6.78137 19.0774 4.91065C17.2035 3.03992 14.7049 2.01331 12.0516 2.01331C6.57885 2.0076 2.1204 6.43916 2.1204 11.8916C2.1204 13.7567 2.64189 15.576 3.63903 17.1502L3.87398 17.5266L2.87112 21.1711L6.63043 20.1901Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.418335 23.5836L2.0573 17.6349C1.04298 15.8954 0.510025 13.9163 0.510025 11.8973C0.515756 5.56645 5.69054 0.41626 12.0516 0.41626C15.1404 0.41626 18.0344 1.61398 20.212 3.78128C22.3897 5.94858 23.5874 8.83451 23.5874 11.903C23.5874 18.2338 18.4069 23.3839 12.0516 23.3839H12.0458C10.1146 23.3839 8.21776 22.8992 6.53294 21.9866L0.418335 23.5836Z",
          fill: "url(#paint0_linear_2992_1894)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.10352e-05 24L1.69633 17.8403C0.647625 16.0323 0.0974822 13.9848 0.103213 11.8916C0.103213 5.3327 5.46711 0 12.0516 0C15.2493 0 18.2522 1.23764 20.5043 3.48479C22.7622 5.73194 24.0058 8.72053 24 11.8973C24 18.4563 18.6362 23.789 12.0459 23.789H12.0402C10.0402 23.789 8.07455 23.2871 6.3267 22.3403L6.10352e-05 24ZM6.63043 20.1901L6.99146 20.4068C8.51581 21.308 10.2637 21.7814 12.0459 21.7871H12.0516C17.5244 21.7871 21.9829 17.3555 21.9829 11.903C21.9829 9.26236 20.9513 6.78137 19.0774 4.91065C17.2035 3.03992 14.7049 2.01331 12.0516 2.01331C6.57885 2.0076 2.1204 6.43916 2.1204 11.8916C2.1204 13.7567 2.64189 15.576 3.63903 17.1502L3.87398 17.5266L2.87112 21.1711L6.63043 20.1901Z",
          fill: "url(#paint1_linear_2992_1894)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.06585 6.91818C8.84235 6.42198 8.6074 6.41058 8.39536 6.40487C8.22344 6.39917 8.02287 6.39917 7.8223 6.39917C7.62172 6.39917 7.30081 6.47331 7.02574 6.76989C6.75067 7.06647 5.98276 7.7851 5.98276 9.25088C5.98276 10.711 7.05439 12.1254 7.20339 12.325C7.35238 12.5246 9.27215 15.6216 12.3037 16.8136C14.8252 17.806 15.3409 17.6064 15.8853 17.5551C16.4297 17.5037 17.6504 16.8364 17.9025 16.1406C18.1489 15.4448 18.1489 14.8516 18.0744 14.7262C17.9999 14.6007 17.7994 14.5265 17.5014 14.3783C17.2034 14.23 15.7363 13.5113 15.4613 13.4087C15.1862 13.3117 14.9856 13.2604 14.7908 13.557C14.5902 13.8535 14.0171 14.5208 13.8452 14.7205C13.6733 14.9201 13.4956 14.9429 13.1977 14.7946C12.8997 14.6463 11.9369 14.3326 10.7965 13.3174C9.90826 12.5303 9.30654 11.5551 9.13462 11.2585C8.9627 10.9619 9.11743 10.8022 9.26642 10.6539C9.39823 10.5227 9.56442 10.306 9.71341 10.1349C9.86241 9.96381 9.91399 9.83833 10.0114 9.63871C10.1088 9.43909 10.063 9.26799 9.98849 9.1197C9.91399 8.97712 9.32946 7.50563 9.06585 6.91818Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint0_linear_2992_1894",
            x1: 12.0023,
            y1: 23.5824,
            x2: 12.0023,
            y2: 0.415449,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#20B038" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#60D66A" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint1_linear_2992_1894",
            x1: 12.0024,
            y1: 23.9977,
            x2: 12.0024,
            y2: 0,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F9F9F9" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "white" })
            ]
          }
        )
      ] })
    ]
  }
);
const VpSocialWhatsappOriginalAsset = forwardRef(SocialWhatsappOriginalAsset);

export { VpSocialWhatsappOriginalAsset as default };
